import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({ theme: 'light', setTheme: () => {}, toggle: () => {} });

const STORAGE_KEY = 'whispersloop.theme';

function getInitialTheme() {
  if (typeof window === 'undefined') return 'light';
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  // Default to light. We intentionally do NOT respect prefers-color-scheme
  // because the manager dashboard is the only surface that supports dark
  // mode — login / marketing / employee portal must always stay light so
  // typing is visible regardless of the OS setting.
  return 'light';
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(getInitialTheme);

  useEffect(() => {
    // IMPORTANT: do NOT add `.dark` to <html>. shadcn's CSS variables hook
    // off the `.dark` class globally, which would break the login page text
    // colours (white text on white background = invisible typing).
    // Each dashboard surface reads `theme` from this context and applies
    // `.dark` to its own root div locally.
    try { localStorage.setItem(STORAGE_KEY, theme); } catch (_e) { /* private mode */ }
  }, [theme]);

  const value = {
    theme,
    setTheme: setThemeState,
    toggle: () => setThemeState(t => (t === 'dark' ? 'light' : 'dark')),
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
